import React from 'react';
import { useAnalytics } from '../../hooks/useAnalytics';
import { FirebaseEvents } from '../../utils/enums/firebase-events';

import { ModalProps } from '../Modal';
import { Button } from '../';

import { ReactComponent as WhatsAppIcon } from '../../assets/whatsapp-rounded.svg';
import { ReactComponent as CallCenterIcon } from '../../assets/call-center-rounded.svg';
import { ReactComponent as Arrow } from '../../assets/arrow-black-right.svg';
import { ReactComponent as WarningModal } from '../../assets/warningModal.svg';

import { maskPhone } from '../../utils/masks';

import * as S from './styles';
import ContainerModal from '../ContainerModal';

export type modalProps = {
  textMessage: string;
  serviceId: string;
  serviceName: string;
  productId: string;
  productName: string;
  unitId: string;
  unitName: string;
} & Pick<ModalProps, 'visible' | 'onClose'>;

const CALL_CENTER_CONTACT = '1121511233';
const WHATS_APP_CONTACT = '1136202550';

export const CallCenterModal: React.FC<modalProps> = ({
  onClose,
  visible,
  textMessage,
  productId,
  productName,
  serviceId,
  serviceName,
  unitId,
  unitName
}) => {
  const { logEvent } = useAnalytics();

  const registerEvent = (eventName: string, reason: string, phoneNumber?: string) => {
    logEvent({
      eventName: eventName,
      eventParams: {
        service_id: serviceId,
        service_name: serviceName,
        product_name: productName,
        product_id: productId,
        unit_id: unitId,
        unit_name: unitName,
        reason: reason,
        ...{ phoneNumber }
      }
    });
  };

  React.useEffect(() => {
    if (visible) registerEvent(FirebaseEvents.schedule_health_insurance_restriction, 'Aviso importante');
  }, [visible]);

  const getWhatsappContactValue = () => WHATS_APP_CONTACT;
  const getCallCenterContactValue = () => CALL_CENTER_CONTACT;

  const handleClickContact = (contactType: 'whatsapp' | 'call_center') => {
    if (contactType === 'whatsapp') {
      registerEvent(FirebaseEvents.schedule_redirect_support_whatsapp, 'Paciente não possui prontuário');

      window.open(`https://api.whatsapp.com/send?phone=55${getWhatsappContactValue()}&text=${textMessage}`, '_blank');
    } else {
      registerEvent(FirebaseEvents.schedule_redirect_call_center, 'Paciente não possui prontuário');
    }
  };

  return (
    <ContainerModal
      visible={visible}
      onClose={onClose}
      withoutCloseButton
      childrenFooter={<Button type="button" title="Fechar" onClick={onClose} />}
    >
      <S.Container>
        <WarningModal />
        <h3 className="title">Aviso importante</h3>
        <p className="subtitle">Identificamos algumas restrições que impedem a continuidade do seu agendamento.</p>
        <p className="subtitle">
          Para seguir com seu atendimento, entre em contato com a nossa Central pelos canais abaixo:
        </p>
        <S.ContactWrapper href={`tel:${getCallCenterContactValue()}`} onClick={() => handleClickContact('call_center')}>
          <S.IconWrapper>
            <CallCenterIcon />
          </S.IconWrapper>
          <S.InfoContainer>
            <S.ContactTitle>{`Call Center ${maskPhone(getCallCenterContactValue())}`}</S.ContactTitle>
            <Arrow />
          </S.InfoContainer>
        </S.ContactWrapper>

        <S.ContactWrapper onClick={() => handleClickContact('whatsapp')}>
          <S.IconWrapper>
            <WhatsAppIcon />
          </S.IconWrapper>
          <S.InfoContainer>
            <S.ContactTitle>{`WhatsApp ${maskPhone(getWhatsappContactValue())}`}</S.ContactTitle>
            <Arrow />
          </S.InfoContainer>
        </S.ContactWrapper>
      </S.Container>
    </ContainerModal>
  );
};
